module.exports = __webpack_public_path__ + "img/ambrpay-disabled.c3fc8cbc.png";